const _ = require('./_');
const { moment } = require('./date-util');

const validRuleTypes = ['truthy', 'falsy', 'minRange', 'equal', 'eq'];

function evaluateRule(ruleType, ruleVariableParameters, ruleFixedParameters, dataType) {
  switch (ruleType) {
    case 'truthy': {
      const variableResult = Array.isArray(ruleVariableParameters) ? ruleVariableParameters.every(p => !!p) : !!ruleVariableParameters;
      if (variableResult) {
        return true;
      }
      const fixedResult = Array.isArray(ruleFixedParameters) ? ruleFixedParameters.every(p => !!p) : !!ruleFixedParameters;
      return fixedResult;
    }
    case 'falsy': {
      const variableResult = Array.isArray(ruleVariableParameters) ? !ruleVariableParameters.some(p => !!p) : !ruleVariableParameters;
      const fixedResult = Array.isArray(ruleFixedParameters) ? !ruleFixedParameters.some(p => !!p) : !ruleFixedParameters;
      return variableResult && fixedResult;
    }
    case 'minRange': {
      if (!Array.isArray(ruleVariableParameters) || (ruleVariableParameters.length !== 2)) {
        throw new Error('2 variable parameters must be provided for the minRange rule');
      }
      const minValue = ruleVariableParameters[0];
      const maxValue = ruleVariableParameters[1];
      if (!minValue || !maxValue) {
        return true; // either the min or max is unbounded
      }
      if (dataType && (dataType.toLowerCase() === 'date' || dataType.toLowerCase() === 'daterange')) {
        if (!Array.isArray(ruleFixedParameters) || (ruleFixedParameters.length !== 2)) {
          throw new Error('2 fixed parameters must be provided for the minRange rule when applied to dates');
        }
        const quantity = ruleFixedParameters[0];
        const increment = ruleFixedParameters[1];
        return moment(minValue).add(quantity, increment).toDate() <= moment(maxValue).toDate();
      }

      if (Array.isArray(ruleFixedParameters) && (ruleFixedParameters.length !== 1)) {
        throw new Error('1 fixed parameters must be provided for the minRange rule when applied to numbers');
      }
      const quantity = Array.isArray(ruleFixedParameters) ? ruleFixedParameters[0] : ruleFixedParameters;
      return minValue + quantity <= maxValue;
    }
    case 'equal':
    case 'eq': {
      let testValue;
      if ((Array.isArray(ruleFixedParameters) && ruleFixedParameters.length > 1) || _.isObject(ruleFixedParameters)) {
        throw new Error('Equality rule requires a single fixed parameter for comparison');
      } else if (Array.isArray(ruleFixedParameters) && ruleFixedParameters.length === 0) {
        throw new Error('Equality rule fixed parameter was missing');
      }
      if (ruleFixedParameters) {
        testValue = Array.isArray(ruleFixedParameters) ? ruleFixedParameters[0] : ruleFixedParameters;
      } else if (Array.isArray(ruleVariableParameters) && ruleVariableParameters.length > 0) {
        testValue = ruleVariableParameters[0]; // eslint-disable-line prefer-destructuring
      } else {
        throw new Error('Equality rule requires at least 2 parameters');
      }

      if (Array.isArray(ruleVariableParameters)) {
        return ruleVariableParameters.every(p => p === testValue);
      }
      return ruleVariableParameters === testValue;
    }
    default:
      throw new Error(`Unknown rule '${ruleType}'`);
  }
}

module.exports = {
  validRuleTypes,
  evaluateRule,
};
